import { render } from "./DobleFactor.vue?vue&type=template&id=91c74052&scoped=true&ts=true"
import script from "./DobleFactor.vue?vue&type=script&lang=ts"
export * from "./DobleFactor.vue?vue&type=script&lang=ts"

import "./css/dobleFactor.css?vue&type=style&index=0&id=91c74052&lang=css&scoped=true&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91c74052"],['__file',"shared/src/entidades/builderMaster/auth/infrastructure/component/DobleFactor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "91c74052"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('91c74052', __exports__)) {
    api.reload('91c74052', __exports__)
  }
  
  module.hot.accept("./DobleFactor.vue?vue&type=template&id=91c74052&scoped=true&ts=true", () => {
    api.rerender('91c74052', render)
  })

}


export default __exports__